const rewriteMetaData = (data: any) => {
  if (data === null) {
    return
  }

  const { title, description, robots } = data
  document.title = title

  const headData = document.head.children
  /* tslint:disable:prefer-for-of no-increment-decrement */
  for (let i = 0; i < headData.length; i++) {
    const nameVal = headData[i].getAttribute('name')
    if (nameVal === null) {
      continue
    }
    if (nameVal.indexOf('description') !== -1 && description) {
      headData[i].setAttribute('content', description)
    }
    if (nameVal.indexOf('robots') !== -1 && robots) {
      headData[i].setAttribute('content', robots)
    }
  }
}

export default rewriteMetaData
